import { useState } from 'react';
import type { ReportBreakdown } from '../../../../types/reports';
import { formatBreakdownValue } from '../reportFormat';

export function BreakdownCard({ breakdown }: { breakdown: ReportBreakdown }) {
  const [expanded, setExpanded] = useState(false);
  const max = breakdown.items.reduce((acc, item) => Math.max(acc, item.value), 0);
  const total = breakdown.items.reduce((acc, item) => acc + item.value, 0);
  const hasMore = breakdown.items.length > 8;
  const visible = expanded ? breakdown.items : breakdown.items.slice(0, 8);

  return (
    <div className="flex flex-col rounded-2xl border border-border bg-surface p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h4 className="text-sm font-semibold text-text">{breakdown.title}</h4>
        {hasMore && (
          <button
            type="button"
            onClick={() => setExpanded((value) => !value)}
            className="text-xs font-medium text-primary hover:underline shrink-0"
          >
            {expanded ? 'Show less' : `Show all ${breakdown.items.length}`}
          </button>
        )}
      </div>
      {breakdown.items.length === 0 ? (
        <p className="text-sm text-text-muted">No data</p>
      ) : (
        <ul className={`space-y-2.5 ${expanded ? 'max-h-80 overflow-y-auto pr-1' : ''}`}>
          {visible.map((item) => {
            const share = total ? (item.value / total) * 100 : 0;
            return (
              <li key={item.label}>
                <div className="flex items-center justify-between gap-3 text-sm">
                  <span className="text-text truncate" title={item.label}>
                    {item.label}
                  </span>
                  <span className="text-text-muted tabular-nums shrink-0">
                    {formatBreakdownValue(item.value, breakdown.format)}
                    {total > 0 && <span className="ml-2 text-xs opacity-70">{share.toFixed(1)}%</span>}
                  </span>
                </div>
                <div className="mt-1 h-1.5 w-full rounded-full bg-background overflow-hidden">
                  <div
                    className="h-full rounded-full bg-primary/70"
                    style={{ width: `${max ? Math.max((item.value / max) * 100, 2) : 0}%` }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
